<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="6" nzXl="6">
        <h1 class="page-title"> Stock</h1>
    </div>
    <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="18" nzXl="18" class="btnsearch">
        <div class="header-right-box">
            <button nz-button nzType="primary" class="right_margin new-btn" (click)="showAddUpdateStock(true)"><i
                    nz-icon nzType="plus"></i> Import</button>
            <button nz-button nzType="primary" class="right_margin new-btn" (click)="showAddUpdateStock()"><i nz-icon
                    nzType="plus"></i> New</button>
            <input type="text" class="search-input right_margin" nz-input
                placeholder="Search here by type at least 3 character ..." [(ngModel)]="searchText"
                (keyup)="onSearch($event)" />
            <i nz-icon nzType="question-circle" nzTheme="outline" nz-tooltip
                nzTooltipTitle="You need to wait for 3 seconds after search apply"></i>
            <div class="check-box">
                <label nz-checkbox [(ngModel)]="isShowArchiveStock" (ngModelChange)="changeArchive($event)">Show Archive
                    Stock</label>
            </div>
        </div>
    </div>
</div>
<!-- <ng-container *ngIf="lst_Stock && lst_Stock.length > 0"> -->
<div class="table-height" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollUpDistance]="1.5"
    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onScrollDown()">
    <nz-table class="main-table-header" #sortTable [nzData]="lst_Stock" nzTableLayout="fixed"
        [nzFrontPagination]="false" [nzShowPagination]="false"
        [ngClass]="{'table-loading' : lst_Stock.length > 0 || isStockLoaded}">
        <thead>
            <tr class="tableheader">
                <!-- <th nzWidth="30px" class="th-width"></th> -->
                <th nzWidth="200px" [nzAlign]="'left'" (nzSortOrderChange)="sort('name')" [nzSortFn]="true"><span
                        class="stock-name-th"> Stock Name</span></th>
                <th nzWidth="200px" [nzAlign]="'left'" (nzSortOrderChange)="sort('etadate')" [nzSortFn]="true"><span
                        nzTooltipTitle="Estimated Stock Arrival Date" [nzTooltipPlacement]="['top']" nz-tooltip
                        [nzTooltipColor]="_cS.tooltipColor">ETA
                        Date </span></th>
                <th nzWidth="200px" [nzAlign]="'left'" (nzSortOrderChange)="sort('status')" [nzSortFn]="true">Stock
                    Location
                </th>
                <th nzWidth="200px" [nzAlign]="'left'">Container Number
                </th>
                <th nzWidth="200px" [nzAlign]="'left'" (nzSortOrderChange)="sort('createdby')" [nzSortFn]="true">Created
                    By
                </th>
                <th nzWidth="150px" [nzAlign]="'left'" (nzSortOrderChange)="sort('createddate')" [nzSortFn]="true">
                    Created Date
                </th>
                <th nzWidth="150px" [nzAlign]="'right'">Action</th>
            </tr>
        </thead>
        <tbody [ngClass]="{'has-data' : lst_Stock.length > 0}">
            <ng-container *ngFor="let data of lst_Stock;let i = index;let even=even;">
                <tr [ngClass]="{'expanded'  : data.expand, 'is-even-row' : even}" class="pointer"
                    (click)="onExpandChange(i,!data.expand,data)">
                    <!-- <td [(nzExpand)]="data.expand" (nzExpandChange)="onExpandChange(i,$event,data)" [nzAlign]="'center'">
                </td>                 -->
                    <td [(nzExpand)]="data.expand" (nzExpandChange)="onExpandChange(i,!data.expand,data)"
                        [nzAlign]="'center'" [nzAlign]="'left'" [nzEllipsis]>
                        <span> {{ data.name }}</span>
                    </td>
                    <td [nzAlign]="'left'">{{ data.etaDate | date : 'MM/dd/yyyy' }}</td>
                    <td [nzAlign]="'left'">
                        <button class="stock-location-btn" nz-button nz-popover
                            [(nzPopoverVisible)]="data.isShowlocationChange" [nzPopoverContent]="contentTemplate"
                            nzPopoverPlacement="bottomLeft" nzPopoverTrigger="click"
                            (click)="$event.stopPropagation(); clickChange()">
                            Change <i nz-icon nzType="caret-down" nzTheme="outline"></i>
                        </button>
                        <ng-template #contentTemplate>
                            <div>
                                <nz-radio-group [ngModel]="data.status" nzName="radiogroup"
                                    (ngModelChange)="changeLocation(data,$event,i)">
                                    <label nz-radio [nzValue]="+r.id"
                                        *ngFor="let r of lst_StockLocation">{{r.value}}</label>
                                </nz-radio-group>
                            </div>
                        </ng-template>
                        {{ data.status == stockLocation.OnProduction ? 'In Production' : (data.status ==
                        stockLocation.InWarehouse ? 'In Warehouse' : 'On Water' )}}
                    </td>
                    <td [nzAlign]="'left'" (click)="onExpandChange(i,!data.expand,data)" [nzEllipsis]>
                        <a nzType="default" class="link" *ngIf="data.containerNumber" target="_blank"
                            [href]="'https://www.oecgroup.com/tracking/cntr/'+data.containerNumber+''">{{
                            data.containerNumber }}</a>
                        <span *ngIf="!data.containerNumber"> -</span>
                    </td>
                    <td [nzAlign]="'left'"> {{ data.createdBy }}</td>
                    <td [nzAlign]="'left'">{{ data.createdOn.slice(0,-1) | date : 'MM/dd/yyyy' }}</td>
                    <td [nzAlign]="'right'">
                       
                        <a *ngIf="data.status == stockLocation.OnProduction && !isShowArchiveStock" class="mr-1"
                            (click)="$event.stopPropagation();editStock(data)" nz-tooltip
                            nzTooltipTitle="Edit Stock"><img src="../assets/images/edit.svg">
                        </a>
                        <a class="mr-1" (click)="$event.stopPropagation();showHistoryModal(data)" nz-tooltip
                            nzTooltipTitle="View Audit Log(s)"><img src="../assets/images/Audit-Icon.png"> </a>
                        <a class="mr-1" (click)="$event.stopPropagation()" nz-tooltip nzTooltipTitle="Archive Stock"
                            nz-popconfirm nzPopconfirmTitle="Are you sure want to archive this stock?"
                            *ngIf="data.isEnableToArchived && !isShowArchiveStock" nzOkText="ok" nzCancelText="cancel"
                            (nzOnConfirm)="archiveStock(data,i)" (nzOnCancel)="cancel()" nzOkText="Yes" nzCancelText="No"><img
                                src="../assets/images/archive_black_24dp.svg"> </a>

                                <a  class="mr-1" (click)="$event.stopPropagation()" nz-popconfirm
                            nzPopconfirmTitle="Are you sure you want to delete this stock?"
                            nzPopconfirmPlacement="left"
                            (nzOnConfirm)="confirm(data,i)"
                            [nzIcon]="iconTpl"
                            (nzOnCancel)="cancel()"
                            nzOkText="Yes" nzCancelText="No"
                                nz-tooltip
                                nzTooltipTitle="Delete Stock"><img src="../assets/images/Delete.svg">
                            </a>
                            <ng-template #iconTpl>
                                <i nz-icon nzType="question-circle-o" style="color: red;"></i>
                            </ng-template>
                            
                    </td>
                </tr>
                <tr [nzExpand]="data.expand">
                    <nz-table class="mt-1" nzTableLayout="fixed" #basicTable [nzData]="data?.partNumbers"
                        [nzShowPagination]="false" [nzScroll]="{ y: 'calc(100vh - 30em)' }"
                        [nzPageSize]="data?.partNumbers?.length">
                        <thead>
                            <tr>
                                <th nzWidth="30px" [nzAlign]="'center'">#</th>
                                <th nzWidth="100px" [nzAlign]="'left'" [nzSortFn]="true"
                                    (nzSortOrderChange)="sortPart(!isAscPart,data.partNumbers)">Part Number</th>
                                <th nzWidth="80px" [nzAlign]="'right'">Ordered</th>
                                <th nzWidth="80px" [nzAlign]="'right'">Assigned</th>
                                <th nzWidth="250px" [nzAlign]="'left'">Notes</th>
                                <th nzWidth="200px" [nzAlign]="'left'">Assignment</th>
                                <th nzWidth="50px" [nzAlign]="'right'">Action</th>
                            </tr>
                        </thead>
        <tbody *ngIf="!isPartNumberLoaded">
            <tr *ngFor="let p of basicTable.data; let pi = index;" [ngClass]="{'is-even-row' : even}">
                <td [nzAlign]="'center'">{{ pi+1 }}</td>
                <td [nzAlign]="'left'">{{p.partNumber }}</td>
                <td [nzAlign]="'right'">{{ p.orderedQuantity }}</td>

                <td [nzAlign]="'right'" (click)="GetAssignmentDetails(p.stockId,p.partNumber,pi,i)">
                    <a nzType="link" nz-button nz-popover [nzPopoverTitle]="titleTemplate" class="pointer"
                        *ngIf="p.totalAssignedQuantity > 0" [nzPopoverPlacement]="'rightTop'"
                        [(nzPopoverVisible)]=" p.visibleAssigned"
                        (nzPopoverVisibleChange)="GetAssignmentDetails(p.stockId,p.partNumber,pi,i)"
                        [nzPopoverContent]="contentTemplate">{{p.totalAssignedQuantity ? p.totalAssignedQuantity :
                        '0'}}
                    </a>
                    <a class="restrict-pointer" nzType="link" nz-button *ngIf="p.totalAssignedQuantity == 0">0</a>

                    <div class="assiged-list-heigth">
                        <ng-template #titleTemplate>
                            Assigned To <img class="float-right close-icon" src="./assets/images/Close.svg"
                                (click)="GetAssignmentDetails(p.stockId,p.partNumber,pi,i)">
                        </ng-template>
                        <ng-template #contentTemplate>
                            <ng-container>
                                <p *ngFor="let a of p?.assignmentList; let ai = index;">
                                    <span
                                        [ngClass]="{'pay-paid' :a.qB_PaymentStatus == 'Paid', 'pay-unpaid' :a.qB_PaymentStatus == 'UnPaid','pay-partial' :a.qB_PaymentStatus == 'PartiallyPaid'}">
                                        <i nzTheme="fill" nz-icon nzType="user" nzTheme="outline"
                                            class="right_margin"></i>
                                        <a class="assignlink"
                                            [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+a.transactionID"
                                            target="_blank">{{ a.invoiceNo }}</a> - {{a.customerName }} - <a
                                            (click)="showAssignmentEdit(a,p)"> ({{a.assignedQuantity }})
                                        </a></span>
                                </p>
                                <div *ngIf="p.assignmentList?.length == 0">
                                    <span class="no-any-assignment">No any assignment</span>
                                </div>
                            </ng-container>
                            <i nz-icon [nzType]="'loading'" *ngIf="!p?.assignmentList"></i>
                        </ng-template>
                    </div>
                </td>

                <td [nzAlign]="'left'" class="note-column">
                    {{p.note ? p.note : '-'}}</td>
                <td nzWidth="200px" [nzAlign]="'left'">
                    <p *ngFor="let a of p.stockPartNumberAssignmentStock; let ai = index;" class="stockAssignmenlst">
                        <span
                            [ngClass]="{'pay-paid' :a.qB_PaymentStatus == 'Paid', 'pay-unpaid' :a.qB_PaymentStatus == 'UnPaid','pay-partial' :a.qB_PaymentStatus == 'PartiallyPaid'}">
                            <i nzTheme="fill" nz-icon nzType="user" nzTheme="outline" class="right_margin"></i>
                            <a class="assignlink"
                                [href]="'https://app.qbo.intuit.com/app/invoice?txnId='+a.transactionID"
                                target="_blank">{{ a.invoiceNo }}</a> - {{a.customerName }} - <a
                                (click)="showAssignmentEdit(a,p)">({{a.assignedQuantity}})</a></span>
                    </p>
                </td>
                <td [nzAlign]="'right'">
                    <a nz-popover [nzPopoverTitle]="'Edit Part'" nzPopoverTrigger="click"
                        [(nzPopoverVisible)]="isEditPartPopOver && currentPartId == p.id"
                        [nzPopoverContent]="addPartNumberTemplate"
                        (nzPopoverVisibleChange)="hideShowEditPart($event,p,data)" nzPopoverPlacement="left">
                        <img *ngIf="data.status == stockLocation.OnProduction" src="../assets/images/edit.svg"
                            class="mr-1">
                    </a>
                    <a class="mr-1" (click)="$event.stopPropagation()" nz-tooltip nzTooltipTitle="Move To Another stock"
                        *ngIf="data.status != stockLocation.InWarehouse && lst_Stock.length > 1 && data.partNumbers.length > 1"
                        nz-popover [nzPopoverTitle]="moveTitleTemplate" class="pointer" [nzPopoverPlacement]="'left'"
                        [(nzPopoverVisible)]="p.isMoveToModalVisible" nzPopoverTrigger="click"
                        (nzPopoverVisibleChange)="moveToAnotherStock($event,i,pi,p.stockId,p.partNumber)"
                        [nzPopoverContent]="moveContentTemplate"><img src="../assets/images/Move-Data.svg">
                        <ng-template #moveTitleTemplate>
                            {{ 'Move ' + movedPartDetail?.partNumber + ' Part Number '}}<img
                                class="float-right close-icon ml-1" src="./assets/images/Close.svg"
                                (click)="moveToAnotherStock(false,i,pi,p.stockId,p.partNumber)">
                        </ng-template>
                        <ng-template #moveContentTemplate>
                            <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                                <nz-form-item>
                                    <nz-form-control nzErrorTip="Please select stock" nzRequired
                                        class="input-field input-box required-input-icon">
                                        <nz-select nzShowSearch nzPlaceHolder="Select Stock" [(ngModel)]="selectedStock"
                                            [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="selectedStock = $event">
                                            <nz-option [nzValue]=c.value [nzLabel]=c.text
                                                *ngFor="let c of lst_AnotherStocks">
                                            </nz-option>
                                        </nz-select>
                                    </nz-form-control>
                                </nz-form-item>
                                <nz-form-item>
                                    <nz-form-control nzErrorTip="Please select assignment Customer" nzRequired
                                        class="input-field input-box required-input-icon">
                                        <nz-select nzShowSearch nzPlaceHolder="Select Customer" nzAllowClear 
                                            [(ngModel)]="selectedCustomer" [ngModelOptions]="{standalone: true}"
                                            (ngModelChange)="selectedCustomer = $event">
                                            <nz-option [nzValue]="c.id" [nzLabel]="c.invoiceNo+' ' + c.customerName"
                                                *ngFor="let c of p?.assignmentList">
                                            </nz-option>
                                        </nz-select>
                                    </nz-form-control>
                                </nz-form-item>
                                <nz-form-item>
                                    <nz-form-control nzErrorTip="Please select quantity" nzRequired
                                        class="input-field input-box required-input-icon">
                                        <input type="number" class="input" nz-input [(ngModel)]="quantityForMove"
                                            placeholder="Enter Quantity" min="1" step="1"
                                            (keypress)="_cS.validateNumber($event)" (keyup)="checkQuantity(p)"
                                            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" />
                                    </nz-form-control>
                                </nz-form-item>
                                <button nz-button nzType="primary" nzSize="small" class="float-right"
                                    [disabled]="isQuantityExists" (click)="movePartNumber(data,p)">
                                    Move</button>
                            </div>
                        </ng-template>
                    </a>
                    <a class="ml-1" nz-popconfirm nzPopconfirmTitle="Are you sure want to remove part?" nzOkText="ok"
                        nzCancelText="cancel" (nzOnConfirm)="removePartNumber(p,data,i,pi)" (nzOnCancel)="cancel()" nzOkText="Yes" nzCancelText="No">
                        <!-- <i nz-icon nzType="close" class="pointer"></i> -->
                        <img class="mr-1 close-icon" src="./assets/images/Close.svg">
                    </a>

                </td>
            </tr>
        </tbody>
        <tbody *ngIf="isPartNumberLoaded">
            <tr *ngFor="let i of [].constructor(5)">
                <ng-container *ngFor="let i of [].constructor(7)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </nz-table>
    </tr>
    </ng-container>
    <!-- <nz-skeleton [nzParagraph]="{ rows: 10 }" [nzActive]="true"></nz-skeleton> -->
    </tbody>
    <ng-container *ngIf="isStockLoaded">
        <tbody>
            <tr *ngFor="let i of [].constructor(100)">
                <ng-container *ngFor="let i of [].constructor(7)">
                    <td [nzAlign]="'left'" class="loading">
                        <div class="bar"></div>
                    </td>
                </ng-container>
            </tr>
        </tbody>
    </ng-container>
    </nz-table>
</div>
<!-- </ng-container> -->

<app-add-update-stock *ngIf="isVisible" [editStockDetail]="editStockDetail" [isImportClicked]="isImportClicked"
    (hideModal)="hideModal($event)">
</app-add-update-stock>
<app-audit-history *ngIf="isAuditVisible" [entityType]="entityType" [entityDetails]="entityDetails"
    (hideModal)="hideAuditModal($event)"></app-audit-history>


<!-- Move part to another stock modal -->
<!-- <nz-modal nzCentered class="custom-modal" [nzMaskClosable]="false" [(nzVisible)]="isMoveToModalVisible"
    [nzTitle]="'Move ' + movedPartDetail?.partNumber + 'Part Number' " [nzWidth]="500" nzOkText="Move"
    nzCancelText="Cancel" (nzOnCancel)="handleCancel()" (nzOnOk)="movePartNumber()">
    <ng-container *nzModalContent>
        <div class="modal-height">
            <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 15, lg: 15 }">
                <div class="gutter-row" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="24">
                    <nz-form-item>
                        <nz-form-control nzErrorTip="Please select stock" nzRequired
                            class="input-field input-box required-input-icon">
                            <nz-select nzShowSearch nzPlaceHolder="Select Stock" [(ngModel)]="selectedStock"
                                [ngModelOptions]="{standalone: true}" (ngModelChange)="selectedStock = $event">
                                <nz-option [nzValue]=c.text [nzLabel]=c.text *ngFor="let c of lst_AnotherStocks">
                                </nz-option>
                            </nz-select>
                        </nz-form-control>
                    </nz-form-item>
                </div>

            </div>
        </div>
    </ng-container>
</nz-modal> -->
<div class="confirm_modal"> 
    <nz-modal [nzVisible]="isVisibleAler" nzCentered nzClassName="alertModal" nzTitle="The first Modal"
        (nzOnCancel)="AlertCancel()" (nzOnOk)="AlertOk()">
        <ng-container *nzModalContent>
            <div class="mainalertbox">
                <h4><i nz-icon nzType="info-circle" nzTheme="outline" class="icon"></i> Are you sure want to move stock
                    to
                    warehouse?</h4>
                <p>After moving stock into the warehouse then it does not revert back to another location</p>
            </div>
        </ng-container>
    </nz-modal>
</div>
<ng-template #addPartNumberTemplate>
    <form nz-form [formGroup]="_fS.addPartNumberForm" class="modal">
        <nz-form-item>
            <nz-form-control nzErrorTip="Part number is required" nzRequired
                class="input-field input-box required-input-icon">
                <input nz-input class="input disable" readonly formControlName="partNumber" />
            </nz-form-control>
            <!-- <nz-form-control nzErrorTip="Part number is required" nzRequired class="input-field input-box required-input-icon">
                <input class="input" nz-input formControlName="partNumber" placeholder="Enter Part Number" />
            </nz-form-control> -->
        </nz-form-item>
        <nz-form-item>
            <nz-form-control nzErrorTip="Ordered quantity is required" nzRequired
                class="input-field input-box required-input-icon">
                <input type="number" class="input" nz-input formControlName="orderQuantiry"
                    placeholder="Enter Ordered Quantity" min="1" step="1" (keypress)="_cS.validateNumber($event)"
                    (focusout)="checkAssignedQuantity()"
                    oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');" />
                <!-- <nz-input-number style="width: 180px;" formControlName="orderQuantiry" placeholder="Enter Ordered Quantity" [nzMin]="1" [nzStep]="1" [nzInputMode]="'numeric'"></nz-input-number> -->
            </nz-form-control>
        </nz-form-item>
        <nz-form-item>
            <nz-form-control class="input-field input-box required-input-icon">
                <textarea class="input" formControlName="notes" nz-input rows="2" maxlength="200"
                    placeholder="Enter Notes"></textarea>
            </nz-form-control>
        </nz-form-item>
        <nz-form-item class="mb-0 text-right">
            <nz-form-control>
                <button nz-button nzType="default" class="modal-footer-btn cancel-btn right_margin"
                    (click)="hideShowEditPart(false,null,null)">Cancel</button>
                <button class="btn-blue modal-footer-btn" nz-button nzType="primary"
                    (click)="updatePartNumber()">Save</button>
            </nz-form-control>
        </nz-form-item>
    </form>
</ng-template>

<app-add-update-assignment *ngIf="isAssignmentVisible" [editAssignmentDetail]="editAssignmentDetail"
    (hideModal)="hideAssignModal($event)">
</app-add-update-assignment>